import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check, MessageCircle, ExternalLink } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CONTACT, waLink } from "@/data/site";

export const CashAppCheckout = ({ plan, price, highlighted }) => {
  const [copied, setCopied] = useState(false);
  const payUrl = `https://cash.app/$${CONTACT.cashtag}/${price}`;

  const copyTag = async () => {
    try {
      await navigator.clipboard.writeText(`$${CONTACT.cashtag}`);
      setCopied(true);
      toast.success("$Cashtag copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar. Cópialo manualmente.");
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          data-testid={`pay-cashapp-trigger-${plan}`}
          className={`mt-2 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-all duration-200 active:scale-95 border ${
            highlighted
              ? "border-[#00D632]/50 text-[#00D632] hover:bg-[#00D632] hover:text-black"
              : "border-white/15 text-white hover:bg-white/5"
          }`}
        >
          <span className="font-bold text-[#00D632]">$</span> Pagar con Cash App
        </button>
      </DialogTrigger>
      <DialogContent className="bg-bp-surface2 border-bp-border text-white sm:max-w-md" data-testid="cashapp-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">
            Pagar con Cash App — <span className="text-bp-primary">${price} USD</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-[#A3A3A3]">
            Envía <strong className="text-white">${price} USD</strong> por Cash App y luego mándanos el comprobante por WhatsApp para activar tu <strong className="text-white">Plan {plan}</strong>.
          </p>

          <div className="rounded-xl border border-bp-border bg-bp-surface p-4 space-y-3">
            <div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-[#737373]">$Cashtag</div>
              <div className="flex items-center justify-between gap-3 mt-1">
                <span className="text-white font-medium text-sm break-all">${CONTACT.cashtag}</span>
                <button
                  onClick={copyTag}
                  data-testid="cashapp-copy-tag"
                  className="shrink-0 inline-flex items-center gap-1 rounded-lg border border-white/15 px-2.5 py-1.5 text-xs text-white hover:bg-white/5 transition-colors"
                >
                  {copied ? <Check className="w-3.5 h-3.5 text-[#00D632]" /> : <Copy className="w-3.5 h-3.5" />}
                  {copied ? "Copiado" : "Copiar"}
                </button>
              </div>
            </div>
            <div className="border-t border-bp-border pt-3">
              <div className="text-[11px] uppercase tracking-[0.15em] text-[#737373]">Titular</div>
              <div className="text-white font-medium text-sm mt-1">{CONTACT.cashName}</div>
            </div>
          </div>

          <a
            href={payUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cashapp-pay-link"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#00D632] px-5 py-3 text-sm font-semibold text-black transition-all duration-200 hover:bg-[#00c02d] active:scale-95"
          >
            <ExternalLink className="w-4 h-4" /> Abrir Cash App y pagar ${price}
          </a>

          <a
            href={waLink(`Hola, acabo de pagar el Plan ${plan} ($${price} USD) por Cash App. Adjunto mi comprobante.`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cashapp-whatsapp"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-5 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-white/5 active:scale-95"
          >
            <MessageCircle className="w-4 h-4 text-[#25D366]" /> Enviar comprobante por WhatsApp
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
